// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login {
  height: 90vh;
  background-color: #151042;
  display: flex;
  justify-content: start;
  align-items: center;
  flex-direction: column;
  gap: 0;
  padding-top: 10vh;
}
.login .login_box {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 15px;
}
.login .login_box img {
  width: 300px;
}
.login .login_box h2 {
  color: #fff;
}
.login .login_box input {
  height: 4vh;
  width: 250px;
  border-radius: 5px;
}
.login .login_box button {
  width: 250px;
}
.login .login_box .password_section {
  position: relative;
}
.login .login_box .password_section .search_btn {
  position: absolute;
  top: 2px;
  right: 5px;
  height: 4vh;
  border-radius: 0.3rem;
  box-shadow: none;
  color: #151042;
}
.login .login_box .login_btn {
  background-color: #ffe169;
  color: #151042;
}
.login .alert_section {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 0;
  margin: 2vh auto;
}
.login .alert_section .alert_box {
  background-color: #151042;
  color: #fff;
  font-weight: 700;
}`, "",{"version":3,"sources":["webpack://./src/components/styles/login.scss","webpack://./src/variables.scss"],"names":[],"mappings":"AAEA;EACI,YAAA;EACA,yBCQe;EAiBf,aAAA;EACA,sBDzBc;EC0Bd,mBD1BqB;EC2BrB,sBD3B6B;EC4B7B,MD5BqC;EACrC,iBAAA;AAGJ;AAFI;ECsBA,aAAA;EACA,uBDtBkB;ECuBlB,mBDvB0B;ECwB1B,sBDxBkC;ECyBlC,SDzB0C;AAQ9C;AAPQ;EACI,YAAA;AASZ;AAPQ;EACI,WCNJ;ADeR;AAPQ;EACI,WAAA;EACA,YAAA;EACA,kBAAA;AASZ;AAPQ;EACI,YAAA;AASZ;AANQ;EACI,kBAAA;AAQZ;AANY;EACI,kBAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,qBAAA;EACA,gBAAA;EACA,cCtBG;AD8BnB;AAJQ;EACI,yBCxBK;EDyBL,cC5BO;ADkCnB;AAFI;ECfA,aAAA;EACA,uBDekB;ECdlB,mBDc0B;ECb1B,sBDakC;ECZlC,MDY0C;EACtC,gBAAA;AAQR;AAPQ;EACI,yBCpCO;EDqCP,WC1CJ;ED2CI,gBAAA;AASZ","sourcesContent":["@import \"../../variables.scss\";\n\n.login {\n    height: 90vh;\n    background-color: $nitrocamDarkBlue;\n    @include flex(start, center, column, 0);\n    padding-top: 10vh;\n    .login_box {\n        @include flex(center, center, column, 15px);\n        img {\n            width: 300px;\n        }\n        h2 {\n            color: $white;\n        }\n        input {\n            height: 4vh;\n            width: 250px;\n            border-radius: 5px;\n        }\n        button {\n            width: 250px;\n        }\n\n        .password_section {\n            position: relative;\n\n            .search_btn {\n                position: absolute;\n                top: 2px;\n                right: 5px;\n                height: 4vh;\n                border-radius: 0.3rem;\n                box-shadow: none;\n                color: $nitrocamDarkBlue;\n            }\n        }\n\n        .login_btn {\n            background-color: $nitrocamYellow;\n            color: $nitrocamDarkBlue;\n        }\n    }\n\n    .alert_section {\n        @include flex(center, center, column, 0);\n        margin: 2vh auto;\n        .alert_box {\n            background-color: $nitrocamDarkBlue;\n            color: $white;\n            font-weight: 700;\n        }\n    }\n}\n","//Colors\n$nitroDark: #2c53a0;\n$nitroLight: #64c4e0;\n$background: #e4ffff;\n$fontColor: #4d4d4d;\n$error: #bb0000;\n$warning: #f29422;\n$white: #fff;\n$black: #000;\n$success: #b6fcc9;\n$green: #357a38;\n\n$nitrocamDarkBlue: #151042;\n$nitrocamBlue: #3b00f8;\n$nitrocamRed: #ff161b;\n$nitrocamYellow: #ffe169;\n\n//Heights\n$nav-height: 10vh;\n$main-height: 80vh;\n$footer-height: 6vh;\n\n//Breakpoints\n$mobile: 600px;\n$tablet: 1000px;\n$desktop: 1300px;\n\n//Layout\n@mixin flex($justify: center, $align: center, $direction: row, $gap: 10px) {\n    display: flex;\n    justify-content: $justify;\n    align-items: $align;\n    flex-direction: $direction;\n    gap: $gap;\n}\n\n//MODAL STYLING\n\n@mixin modal($h: auto, $w: auto) {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: $w;\n    height: $h;\n    max-height: 60vh;\n    background-color: #fff;\n    border-radius: 5px;\n    box-shadow: 24;\n    padding: 10px;\n    overflow-y: auto;\n    @media (max-width: 1000px) {\n        width: 92vw;\n    }\n}\n\n//Overflow\n@mixin scrollbars(\n    $size,\n    $foreground-color,\n    $background-color: mix($foreground-color, white, 50%)\n) {\n    // For Google Chrome\n    &::-webkit-scrollbar {\n        width: $size;\n        height: $size;\n    }\n\n    &::-webkit-scrollbar-thumb {\n        background: $foreground-color;\n    }\n\n    &::-webkit-scrollbar-track {\n        background: $background-color;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
